function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M73 84.7988H103.59V55.623H73V84.7988ZM75.9883 58.5278H100.603V68.7588H75.9883V58.5278ZM75.9883 71.6633H100.603V81.8943H75.9883V71.6633Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M116.713 78.5606C118.268 74.8978 119.189 71.0889 119.709 66.9932H115.464C117.353 64.6044 118.965 61.1547 119.416 57.415H110.096V60.1874H115.664C115.049 62.4646 113.815 64.9263 112.342 66.9932H109.802V69.7545H116.191C115.914 71.6713 115.375 73.6636 114.663 75.6154C114.359 75.1283 114.063 74.633 113.766 74.1589L113.026 72.7187H109.861C110.834 74.7519 111.977 76.8677 113.358 78.7447C112.835 79.8621 112.266 80.9417 111.667 81.9591C111.068 82.9765 110.356 84.001 109.627 84.7991H112.32C112.87 84.7991 113.556 84.4261 113.844 83.9706C113.844 83.9706 114.826 82.4162 115.46 81.2008C117.576 83.2966 120.153 84.7332 123.35 84.7991L146.687 84.7993L147.599 82.0682L124.514 82.0686C121.354 82.0041 118.805 80.6037 116.713 78.5606Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M131.516 66.116H122.053V68.5311H131.516V70.6945H122.053V73.1258H131.516V75.487H119.591V77.9085H131.516V80.9836H135.007V77.9085H146.932V75.487H135.007V73.1256H144.47V70.6945H135.007V68.5311H144.47V63.6543H146.932V61.2423H144.47V56.6762H135.007V55H131.516V56.6762H122.053V59.1044H131.516V61.2426H119.591V63.6545H131.516V66.116ZM141.48 66.116H135.007V63.6543H141.48V66.116ZM135.007 59.1042H141.48V61.2423H135.007V59.1042Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M168.054 55.623H153.66V58.4308H168.054V55.623Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M168.91 60.8982H152.822V63.7039H168.91V60.8982Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M168.054 65.7244H153.66V68.2511H168.054V65.7244Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M168.054 70.3477H153.66V72.8609H168.054V70.3477Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M153.66 84.7986H168.054V75.0864H153.66V84.7986ZM156.649 77.6042H165.067V82.2853H156.649V77.6042Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M187.197 63.2642V55.623H173.616V63.2642C173.616 64.6247 172.575 64.9707 171.402 65.0859L169.718 65.2311L170.561 67.7542L171.228 67.7318C175.328 67.4457 176.505 66.1134 176.505 63.2642V58.4308H184.308V63.2642C184.308 66.5339 186.025 67.3929 188.605 67.7018L190.205 67.8754L191.1 65.1955L189.145 65.0711C187.871 65.0006 187.197 64.5112 187.197 63.2642Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M182.397 79.3731C185.756 76.5418 189.029 73.0736 190.185 69.698H170.536V71.8362C172.706 74.463 175.195 77.0568 178.076 79.5334C176.909 80.3752 175.631 81.2268 174.231 82.1003C172.832 82.9739 171.184 83.9547 169.484 84.7986H173.802C174.352 84.7986 175.18 84.5614 175.642 84.2717C175.642 84.2717 178.016 82.7839 180.108 81.2C181.686 82.4447 184.355 84.2442 184.355 84.2442C184.807 84.5491 185.626 84.7983 186.176 84.7986H190.755C189.392 84.0922 187.881 83.1713 186.501 82.2604C185.12 81.3498 183.736 80.3809 182.397 79.3731ZM174.711 72.3107H185.483C184.218 74.2012 182.535 75.9849 180.358 77.7748C178.186 76.0055 176.219 74.153 174.711 72.3107Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M211.836 55.623H196.612V58.4308H211.836V55.623Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M212.692 60.8987H195.773V63.7044H212.692V60.8987Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M211.836 65.7244H196.612V68.2511H211.836V65.7244Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M211.836 70.3486H196.612V72.8619H211.836V70.3486Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M196.612 84.7993H211.836V75.0872H196.612V84.7993ZM199.601 77.605H208.849V82.2861H199.601V77.605Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M233 65.7245H224.635V55H221.145V65.7245H212.78V68.2512H221.145V85.4225H224.635V68.2512H233V65.7245Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoNs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNs);
export default __webpack_public_path__ + "static/media/logo_ns.359f6e13.svg";
export { ForwardRef as ReactComponent };